import React from 'react';

const PayDutiesError = ({ text }) => {
  return (
    <div className='payDuties'>
      <div className='animated bounceIn status-payment-box error'>
        <div>
          <i className='glyphicon glyphicon-remove-circle' aria-hidden='true' />
        </div>
        {text}
      </div>
    </div>
  );
};

export default PayDutiesError;
